import React from "react";

const DriverDashboardLoadableComponent = React.lazy(() => import("./DriverDashboard/driver-dashboard"));
const DriverDashboardNewLoadableComponent = React.lazy(() => import("./DriverDashboard/driver-dashboard-new"));
const SupervisorDashboardLoadableComponent = React.lazy(() => import("./SupervisorDashboard/SupervisorDashboard"));
const VehicleDashboardLoadableComponent = React.lazy(() => import("./VehicleDashboard/VehicleDashboard"));
const TrackDriverMapLoadableComponent = React.lazy(() => import("./DriverDashboard/TrackDriverMap"));
const CustomerComplaintDashboardLoadableComponent = React.lazy(() => import("./CustomerComplaintDashboard/CustomerComplaintDashboard"));

export {
    TrackDriverMapLoadableComponent,
    DriverDashboardLoadableComponent,
    DriverDashboardNewLoadableComponent,
    SupervisorDashboardLoadableComponent,
    VehicleDashboardLoadableComponent,
    CustomerComplaintDashboardLoadableComponent
};